import {
	appearances,
	controllers,
} from '@foxitsoftware/foxit-pdf-sdk-for-web-library'

export const PrinterIconSVG = `
<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true" data-slot="icon" class="size-6"><path stroke-linecap="round" stroke-linejoin="round" d="M6.72 13.829c-.24.03-.48.062-.72.096m.72-.096a42.415 42.415 0 0 1 10.56 0m-10.56 0L6.34 18m10.94-4.171c.24.03.48.062.72.096m-.72-.096L17.66 18m0 0 .229 2.523a1.125 1.125 0 0 1-1.12 1.227H7.231c-.662 0-1.18-.568-1.12-1.227L6.34 18m11.318 0h1.091A2.25 2.25 0 0 0 21 15.75V9.456c0-1.081-.768-2.015-1.837-2.175a48.055 48.055 0 0 0-1.913-.247M6.34 18H5.25A2.25 2.25 0 0 1 3 15.75V9.456c0-1.081.768-2.015 1.837-2.175a48.041 48.041 0 0 1 1.913-.247m10.5 0a48.536 48.536 0 0 0-10.5 0m10.5 0V3.375c0-.621-.504-1.125-1.125-1.125h-8.25c-.621 0-1.125.504-1.125 1.125v3.659M18 10.5h.008v.008H18V10.5Zm-3 0h.008v.008H15V10.5Z"></path></svg>
`

export const CustomAppearance = appearances.Appearance.extend({
	getLayoutTemplate: () => `
        <webpdf>
            <toolbar class="flex items-center py-2 px-8">
                <group name="navigation-group" class="flex">
                    <text-sel:text-selection-tooltip>
                    </text-sel:text-selection-tooltip>
                    <hand-ribbon-button></hand-ribbon-button>
                    <ink-sign-ribbon-dropdown></ink-sign-ribbon-dropdown>
                    <template>
                        <create-ink-sign-dialog></create-ink-sign-dialog>
                    </template>
                </group>
                <group name="navigation-group" class="flex items-center">
                    <zoom-in-ribbon-button></zoom-in-ribbon-button>
                    <zoom-out-ribbon-button></zoom-out-ribbon-button>
                    <goto-prev-page-button
                        @controller="gotoview:GotoPrevPageController"
                    ></goto-prev-page-button>
                    <number
                        class="flex max-w-[50px] justify-center"
                        min="1"
                        name="gotopage-input"
                        @controller="pageview:GotoPageController"
                        @bind.attr.max="pageNumber"
                        @bind.value="currentPageIndex"
                        @on.change="onchange"
                        @on.keydown="onkeydown"
                    ></number>
                    <goto-next-page-button
                        @controller="gotoview:GotoNextPageController"
                    ></goto-next-page-button>
                </group>
                <button class="border-2 border-accent-400! px-2 py-3 flex items-center justify-center ml-4 text-accent-400!" name="autofill-btn" id="autofill-btn" tabindex="0" aria-label="autofill">
                    RESET FORM
                </button>
                <button class="border-2 border-accent-400! px-2 py-3 flex items-center justify-center ml-4 text-accent-400!" name="change-payment-type-btn" id="change-payment-type-btn" tabindex="0" aria-label="change payment type">
                    CHANGE PAYMENT DETAILS
                </button>
                <button class="border-2 border-accent-400! px-2 py-3 flex items-center justify-center ml-4 text-accent-400!" name="add-custom-item-btn" id="add-custom-item-btn" tabindex="0" aria-label="add custom item">
                    ADD CUSTOM ITEM
                </button>
            </toolbar>
            <div class="fv__ui-body">
                <viewer @touch-to-scroll></viewer>
            </div>
        </webpdf>
    `,
})

export const CustomPreviewAppearance = appearances.Appearance.extend({
	getLayoutTemplate: () => `
        <webpdf>
            <toolbar class="flex items-center py-2">
                <group name="navigation-group" class="flex items-center">
                    <text-sel:text-selection-tooltip>
                    </text-sel:text-selection-tooltip>
                    <zoom-in-ribbon-button></zoom-in-ribbon-button>
                    <zoom-out-ribbon-button></zoom-out-ribbon-button>
                    <download-file-ribbon-button></download-file-ribbon-button>
                    <button
                        name="print-preview-btn"
                        class="flex flex-col px-3 pb-7 gap-1 items-center justify-center hover:bg-slate-200"
                        tabindex="0"
                    >
                        <div class="fx-ribbon-item-icon opacity-60 pt-1.5">
                            ${PrinterIconSVG}
                        </div>
                        <div class="transform translate-y-1.25">
                            Print
                        </div>
                    </button>
                    <goto-prev-page-button
                        @controller="gotoview:GotoPrevPageController"
                    ></goto-prev-page-button>
                    <number
                        min="1"
                        name="gotopage-input"
                        @controller="pageview:GotoPageController"
                        @bind.attr.max="pageNumber"
                        @bind.value="currentPageIndex"
                        @on.change="onchange"
                        @on.keydown="onkeydown"
                    ></number>
                    <goto-next-page-button
                        @controller="gotoview:GotoNextPageController"
                    ></goto-next-page-button>
                </group>
            </toolbar>
            <div class="fv__ui-body">
                <viewer @touch-to-scroll></viewer>
            </div>
        </webpdf>
    `,
})

export const FoxitFragments = [
	{
		target: 'selection-text-annotation',
		config: {
			callback: controllers.SelectTextAnnotationController,
		},
	},
	{
		target: 'fv--contextmenu-item-form-showSignProperty',
		config: {
			callback: controllers.SignPropertyController,
		},
	},
	{
		target: 'gotopage-input',
		config: {
			callback: controllers.GotoPageController,
		},
	},
	{
		target: 'goto-prev-page',
		config: {
			callback: controllers.GotoPrevPageController,
		},
	},
	{
		target: 'goto-next-page',
		config: {
			callback: controllers.GotoNextPageController,
		},
	},
	{
		target: 'autofill-btn',
		config: {
			callback: () =>
				document.dispatchEvent(new CustomEvent('foxit-autofill-button')),
		},
	},
	{
		target: 'change-payment-type-btn',
		config: {
			callback: () =>
				document.dispatchEvent(
					new CustomEvent('foxit-change-payment-type-button')
				),
		},
	},
	{
		target: 'add-custom-item-btn',
		config: {
			callback: () =>
				document.dispatchEvent(new CustomEvent('foxit-add-custom-item-button')),
		},
	},
]
export const FoxitPreviewFragments = [
	{
		target: 'selection-text-annotation',
		config: {
			callback: controllers.SelectTextAnnotationController,
		},
	},
	{
		target: 'gotopage-input',
		config: {
			callback: controllers.GotoPageController,
		},
	},
	{
		target: 'goto-prev-page',
		config: {
			callback: controllers.GotoPrevPageController,
		},
	},
	{
		target: 'goto-next-page',
		config: {
			callback: controllers.GotoNextPageController,
		},
	},
	{
		target: 'print-preview-btn',
		config: {
			callback: () => {
				window.dispatchEvent(new CustomEvent('print-preview-trigger'))
			},
		},
	},
]
